import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const DefaultBanner = () => { 
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "default-banner.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 220) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
 
  return (
    <Img fluid={data.placeholderImage.childImageSharp.fluid} />
  )
}

export default DefaultBanner
